export default {
    get(name = 'token') {
        if(this.useCookie()){
            return this.getCookie(name)
        }else{
            return localStorage.getItem(name)
        }
    },
    set(name = 'token',value,day = 365) {
        if(this.useCookie()){
            this.setCookie(name,value,day)
            this.postCrossDomainMessage({name:name,value:value,day:day});
        }else{
            localStorage.setItem(name, value)
            this.postCrossDomainMessage({name:name,value:value,day:day});
        }
    },
    del(name = 'token',day = 365) {
        if(this.useCookie()){
            this.removeCookie(name)
            this.postCrossDomainMessage({name:name,value:'',day:day});
        }else{
            localStorage.removeItem(name)
            this.postCrossDomainMessage({name:name,value:'',day:day});
        }
    },
    postCrossDomainMessage(msg) {
        return
        if(1 || this.useCookie()){
            var parent = document.querySelector('#all-js-iframe')
            var children = parent.childNodes;
            for (var i = 0; i < children.length; i++) {
                var win = children[i].contentWindow;
                win.postMessage(msg, children[i].src)
            }
        }
    },
    getDomain(){
        return ';domain='+document.domain.split('.').slice(-2).join('.')
    },
    setCookie(name, value, iDay) {
        value = value ? value : ''
        document.cookie = name + '=' + value + this.getDomain()+';expires=' + this.getExpires(iDay)+';path=/';
    },
    getExpires(iDay){
        var now = new Date();
        var expires = new Date(now.getTime() + iDay * 24 * 60 * 60 * 1000);
        return expires.toUTCString();
    },
    getCookie(name) {
        var arr = document.cookie.split('; ');
      for (var i in arr) {
        var arr2 = arr[i].split('=');
        if (arr2[0] == name) {
            return arr2[1];
        }
      }
      return '';
    },
    removeCookie(name) {
        this.setCookie(name, 1, -1);
    },
    useCookie(){
        return true
        /*if (process.env.NODE_ENV == 'app' || process.env.NODE_ENV == 'production') {
            return true
        }
        return false*/
    }
}